import { AsyncThunkAction } from 'actions/actions.types'
import { fetchUniNoticeAction } from 'actions/uninotice/uniNoticeAction'
import {
  incognitoRequestDeclinedNoticeId,
  incognitoRequiredNoticeId,
  incognitoRequiredSentNoticeId,
} from 'components/uninotice/uniNoticeIdList'

export const fetchIncognitoRequestStatusUniNoticeAction =
  (userId: number | string): AsyncThunkAction =>
  async (dispatch, getState) => {
    const {
      profile: { incognitoRequestStatus },
    } = getState()

    if (!incognitoRequestStatus) {
      console.error('Missing incognito request status data')
      return
    }

    const { isDeclined, isPending, isSent } = incognitoRequestStatus

    if (isDeclined) {
      await dispatch(
        fetchUniNoticeAction(incognitoRequestDeclinedNoticeId, undefined)
      )
    }

    // Запрашивалось. Ждем ответа
    if (isSent && isPending) {
      await dispatch(
        fetchUniNoticeAction(incognitoRequiredSentNoticeId, undefined)
      )
    }

    // Никогда не запрашивалось, нужно вызывать типс с incognito
    if (!isSent) {
      await dispatch(
        fetchUniNoticeAction(incognitoRequiredNoticeId, { userId })
      )
    }
  }
